import React, { FC } from "react";
import { Segment, Checkbox, Grid } from "semantic-ui-react";

import _ from "lodash";

import type { PianoChartLocationSelectorProps } from "./types";

const PianoChartLocationSelector: FC<PianoChartLocationSelectorProps> = ({ locations, updateSelectedLocation }) => {
	return (
		<Segment basic>
			<Grid>
				<label>Location</label>
				{_.map(_.orderBy(locations, ["countryCode", "region", "city"]), (l) => {
					return (
						<Grid.Row key={l.trialId}>
							<Checkbox
								label={`${l.city}, ${l.region}, ${l.countryCode}`}
								checked={l.checked}
								onChange={(_event, { checked }) => {
									// A Checkbox (not indeterminate) always reports a boolean `checked`.
									updateSelectedLocation(l.trialId, checked!);
								}}
							/>
						</Grid.Row>
					);
				})}
			</Grid>
		</Segment>
	);
};

export default PianoChartLocationSelector;
